import { render, staticRenderFns } from "./ColumnFlag.vue?vue&type=template&id=3890a60e"
import script from "./ColumnFlag.vue?vue&type=script&lang=js"
export * from "./ColumnFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3890a60e')) {
      api.createRecord('3890a60e', component.options)
    } else {
      api.reload('3890a60e', component.options)
    }
    module.hot.accept("./ColumnFlag.vue?vue&type=template&id=3890a60e", function () {
      api.rerender('3890a60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/Columns/ColumnFlag.vue"
export default component.exports